import React, { useState, useRef } from 'react';
import { Table, Container, Row, Col, Card } from 'react-bootstrap';
import SchumannOp2201 from './assets/mp3/01-C.Schumann-Opera_22.mp3';
import SchumannOp2202 from './assets/mp3/02-C.Schumann-Opera_22.mp3';
import SchumannOp2203 from './assets/mp3/03-C.Schumann-Opera_22.mp3';
import Brahms7801 from './assets/mp3/04-Brahms_Sonata_Opera_78-1.mp3';
import Brahms7802 from './assets/mp3/05-Brahms_Sonata_Opera_78-2.mp3';
import Brahms7803 from './assets/mp3/06-Brahms_Sonata_Opera_78-3.mp3';
import Debussy1 from './assets/mp3/08-Debussy_Sonata_1.mp3';
import Debussy2 from './assets/mp3/09-Debussy_Sonata_2.mp3';
import Debussy3 from './assets/mp3/10-Debussy_Sonata_3.mp3';
import Ravel1 from './assets/mp3/07-Ravel-Sonata_Postuma.mp3';
import { useTranslation } from 'react-i18next';

const ConcertTable = () => {
    const [currentAudio, setCurrentAudio] = useState(null);
    const audioRefs = useRef([]);

    const { t } = useTranslation();

    const handlePlay = (index) => {
        if (currentAudio && currentAudio !== audioRefs.current[index]) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
        }
        setCurrentAudio(audioRefs.current[index]);
    };
    const events = [
        { year: 1980, description: t("concerti.c1") },
        { year: 1980, description: t("concerti.c2") },
        { year: 1981, description: t("concerti.c3") },
        { year: 1981, description: t("concerti.c4") },
        { year: 1981, description: t("concerti.c5") },
        { year: 1982, description: t("concerti.c6") },
        { year: 1982, description: t("concerti.c7") },
        { year: 1982, description: t("concerti.c8") },
        { year: 1982, description: t("concerti.c9") },
        { year: 1982, description: t("concerti.c10") },
        { year: 1983, description: t("concerti.c11") },
        { year: 1983, description: t("concerti.c12") },
        { year: 1984, description: t("concerti.c13") },
        { year: 1986, description: t("concerti.c14") },
        { year: 1986, description: t("concerti.c15") },
        { year: 1986, description: t("concerti.c16") },
        { year: 1986, description: t("concerti.c17") },
        { year: 1986, description: t("concerti.c18") },
        { year: 1986, description: t("concerti.c19") },
        { year: 1987, description: t("concerti.c20") },
        { year: 1987, description: t("concerti.c21") },
        { year: 1988, description: t("concerti.c22") },
        { year: 1988, description: t("concerti.c23") },
        { year: 1989, description: t("concerti.c24") },
        { year: 1989, description: t("concerti.c25") },
        { year: 1989, description: t("concerti.c26") },
        { year: 1989, description: t("concerti.c27") },
        { year: 1990, description: t("concerti.c28") },
        { year: 1990, description: t("concerti.c29") },
        { year: 1990, description: t("concerti.c30") },
        { year: 1991, description: t("concerti.c31") },
        { year: 1991, description: t("concerti.c32") },
        { year: 1992, description: t("concerti.c33") },
        { year: 1992, description: t("concerti.c34") },
        { year: 1992, description: t("concerti.c35") },
        { year: 1992, description: t("concerti.c36") },
        { year: 1992, description: t("concerti.c37") },
        { year: 1993, description: t("concerti.c38") },
        { year: 1994, description: t("concerti.c39") },
        { year: 1994, description: t("concerti.c40") },
        { year: 1995, description: t("concerti.c41") },
        { year: 1997, description: t("concerti.c42") },
        { year: 1997, description: t("concerti.c43") },
        { year: 2000, description: t("concerti.c44") },
        { year: 2004, description: t("concerti.c45") },
        { year: 2004, description: t("concerti.c46") },
        { year: 2004, description: t("concerti.c47") },
        { year: 2009, description: t("concerti.c48") },
        { year: 2010, description: t("concerti.c49") },
        { year: 2011, description: t("concerti.c50") },
        { year: 2011, description: t("concerti.c51") },
        { year: 2012, description: t("concerti.c52") },
        { year: 2013, description: t("concerti.c53") },
        { year: 2014, description: t("concerti.c54") },
        { year: 2014, description: t("concerti.c55") },
        { year: 2015, description: t("concerti.c56") },
        { year: 2015, description: t("concerti.c57") },
        { year: 2015, description: t("concerti.c58") },
        { year: 2015, description: t("concerti.c59") },
        { year: 2017, description: t("concerti.c60") },
        { year: 2017, description: t("concerti.c61") },
        { year: 2017, description: t("concerti.c62") },
        { year: 2018, description: t("concerti.c63") },
        { year: 2018, description: t("concerti.c64") }
    ];    
const videos = [
    {
        title: 'Sonata Op.30 n.3',
        author: 'L.V. Beethoven',
        url: 'https://www.youtube.com/embed/kskFp5G6N2s?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Gaspard de la Nuit',
        author: 'M. Ravel',
        url: 'https://www.youtube.com/embed/vPyQZcdYoT8?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Sonata Op.110 - in tre tempi',
        author: 'L.V. Beethoven',
        url: 'https://www.youtube.com/embed/zzEBdVsSL9o?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Sonatina Seconda',
        author: 'F. Busoni',
        url: 'https://www.youtube.com/embed/65cvypgKYc0?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Piano-Sonata',
        author: 'A. Berg',
        url: 'https://www.youtube.com/embed/dZ-SX4tJx9s?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Ballata n. 4',
        author: 'F. Chopin',
        url: 'https://www.youtube.com/embed/B-mgANJyijs?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'L’isle joyeuse',
        author: 'C. Debussy',
        url: 'https://www.youtube.com/embed/-a4BsHGBBe4?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Kammer-Phantasie über "Carmen"',
        author: 'F. Busoni',
        url: 'https://www.youtube.com/embed/iFphDyZdrbU?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Variations on a Theme by R. Schumann',
        author: 'C. Schumannn',
        url: 'https://www.youtube.com/embed/x90D0LRnM2E?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Variations on a Theme by R. Schumann',
        author: 'J. Brahms',
        url: 'https://www.youtube.com/embed/45s6CldfIYc?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Partita No. 4 in re maggiore',
        author: 'J. S. Bach',
        url: 'https://www.youtube.com/embed/Q2xf3qDwpuQ?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Danze Piemontesi',
        author: 'L. Sinigaglia',
        url: 'https://www.youtube.com/embed/UKJ3dlmtbG0?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'L’artista',
        author: 'C. Rossaro',
        url: 'https://www.youtube.com/embed/Aakthej5uA4?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Dolly',
        author: 'G. Faurè',
        url: 'https://www.youtube.com/embed/ZTfPG3o3kYg?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Danze slave',
        author: 'A. Dvoràk',
        url: 'https://www.youtube.com/embed/GRlKj90JNJI?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'La boîte à joujoux',
        author: 'C. Debussy',
        url: 'https://www.youtube.com/embed/sLIiIz53iB8?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'L’Auriga Celeste',
        author: 'Tiziano Bedetti',
        url: 'https://www.youtube.com/embed/ifNsGoHYvsI?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Sonata in si bemolle maggiore K454',
        author: 'W.A. Mozart',
        url: 'https://www.youtube.com/embed/Gs4SKIk8Dk0?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Sonata n.2 in re maggiore',
        author: 'S. Prokof’ev',
        url: 'https://www.youtube.com/embed/5vo1KNo5Ohw?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Sonate en sol',
        author: 'M. Ravel',
        url: 'https://www.youtube.com/embed/MK__dpkXs9M?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Sonate pour violon et piano',
        author: 'C. Debussy',
        url: 'https://www.youtube.com/embed/SyGJOrq9I3g?rel=0&modestbranding=1&controls=1'
    },
    {
        title: 'Sonata in re minore - "La Tempesta"',
        author: 'L.V. Beethoven',
        url: 'https://www.youtube.com/embed/u8aMzjsfRbM?rel=0&modestbranding=1&controls=1'
    }
];
const audioFiles = [
    { title: 'Romanza op. 22 n. 1', composer: 'C. Schumann', url: SchumannOp2201 },
    { title: 'Romanza op. 22 n. 2', composer: 'C. Schumann', url: SchumannOp2202 },
    { title: 'Romanza op. 22 n. 3', composer: 'C. Schumann', url: SchumannOp2203 },
    { title: 'Sonata op. 78 - 1°', composer: 'J. Brahms', url: Brahms7801 },
    { title: 'Sonata op. 78 - 2°', composer: 'J. Brahms', url: Brahms7802 },
    { title: 'Sonata op. 78 - 3°', composer: 'J. Brahms', url: Brahms7803 },
    { title: 'Sonata - 1°', composer: 'C. Debussy', url: Debussy1 },
    { title: 'Sonata - 2°', composer: 'C. Debussy', url: Debussy2 },
    { title: 'Sonata - 3°', composer: 'C. Debussy', url: Debussy3 },
    { title: 'Sonata Postuma', composer: 'M. Ravel', url: Ravel1 },
];


return (
    <Container className='my-5'>
        <Table striped bordered hover>
            <tbody>
                {events.map((event, index) => (
                    <tr key={index}>
                        <td>{event.year}</td>
                        <td>{event.description}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
        <Row>
            {videos.map((video, index) => (
                <Col key={index} md={6} lg={4} className="mb-4">
                    <Card className="h-100">
                        <Card.Body className="d-flex flex-column align-items-center justify-content-between">
                            <div className="text-center">
                                <Card.Title>{video.title}</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">{video.author}</Card.Subtitle>
                            </div>
                            <div className="embed-responsive embed-responsive-16by9">
                                <iframe
                                    className="embed-responsive-item rounded-3"
                                    src={video.url}
                                    allowFullScreen
                                    title={video.title}
                                ></iframe>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
        <hr></hr>
        <Row>
            {audioFiles.map((audio, index) => (
            <Col key={index} md={6} lg={4} className="mb-4">
                <Card className="h-100">
                <Card.Body className="d-flex flex-column align-items-center justify-content-between">
                    <div className="text-center">
                    <Card.Title>{audio.title}</Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">{audio.composer}</Card.Subtitle>
                    </div>
                    <audio
                    ref={(el) => (audioRefs.current[index] = el)}
                    controls
                    className="w-100"
                    onPlay={() => handlePlay(index)}
                    >
                    <source src={audio.url} type="audio/mp3" />
                    Your browser does not support the audio element.
                    </audio>
                </Card.Body>
                </Card>
            </Col>
            ))}
        </Row>
    </Container>
);
};

export default ConcertTable;
